module.exports = __webpack_public_path__ + "static/media/USA.388f01b5.svg";